import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { getCleanedUrlParams, showError } from '@utils';
import { tiresServices } from '@services';

import { QUERY_KEYS } from '../../../constants/queryKeys';
import { getSearchRequestPayload, handleTiresData } from './utils';

export const TIRES_PAGE_SIZE = 250;

export const useTiresOperations = () => {
  const router = useRouter();
  const page = router.query?.page || 1;
  const pageSize = router.query?.pageSize || TIRES_PAGE_SIZE;

  const queryParams = {
    page,
    pageSize: parseInt(pageSize, 10),
  };

  const queryParamsCleaned = getCleanedUrlParams(queryParams);

  const tiresResponse = useQuery(
    [QUERY_KEYS.GET_MARKETPLACE_TIRES_KEY, queryParamsCleaned, router.query],
    () => {
      const searchPayload = getSearchRequestPayload(router.query);

      return tiresServices.searchTires(queryParamsCleaned, searchPayload);
    }
  );

  useEffect(() => {
    if (tiresResponse?.error) {
      showError(tiresResponse?.error);
    }
  }, [tiresResponse?.error]);

  return {
    page,
    total: tiresResponse?.data?.meta?.total,
    error: tiresResponse?.error,
    isSuccess: tiresResponse?.isSuccess,
    loading: tiresResponse?.isLoading || tiresResponse?.isFetching,
    pageSize: parseInt(pageSize, 10) || TIRES_PAGE_SIZE,
    rows: handleTiresData(tiresResponse?.data?.data),
    refresh: tiresResponse.refetch,
  };
};
